'use client';

import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

import { HoverPopper } from '.';

import type { HoverPopperProps } from './HoverPopper';
import type { FC } from 'react';

/**
 * HoverPopperNavigation
 * @augments HoverPopperControlled
 * dropdown
 * controlled Popper. Closing when navigating to a new url
 */

// eslint-disable-next-line react/require-default-props
export const HoverPopperNavigation: FC<HoverPopperProps> = (props) => {
  const { pathname } = useRouter();

  const [open, setOpen] = useState( false );

  useEffect( () => {
    if (open) setOpen( true );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname] );

  return <HoverPopper open={open} {...props} />;
};
